import { render, staticRenderFns } from "./UpdatePhoneNumberNew.vue?vue&type=template&id=2d3f6563&"
import script from "./UpdatePhoneNumberNew.vue?vue&type=script&lang=ts&"
export * from "./UpdatePhoneNumberNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports